/**
 * Context-specific thinking messages for Righty's loading indicator.
 * These rotate with a typewriter effect while waiting for a response.
 */
export const THINKING_MESSAGES: Record<string, string[]> = {
  email: [
    'Reviewing your other emails...',
    'Researching copywriting best-practices...',
    'Generating personalized variants...',
    'Analyzing your analytics data...'
  ],
  flow: [
    'Analyzing your flow structure...',
    'Reviewing conversion patterns...',
    'Evaluating branching logic...',
    'Checking for optimization opportunities...'
  ],
  widget: [
    'Reviewing widget configurations...',
    'Analyzing display triggers...',
    'Checking targeting rules...',
    'Evaluating engagement patterns...'
  ],
  campaign: [
    'Analyzing campaign performance...',
    'Reviewing personalization rules...',
    'Checking variant configurations...',
    'Evaluating audience targeting...'
  ],
  segment: [
    'Reviewing segmentation strategy...',
    'Analyzing visitor patterns...',
    'Evaluating targeting rules...',
    'Checking dimension configurations...'
  ],
  visitors: [
    'Analyzing visitor data...',
    'Reviewing engagement history...',
    'Checking segment memberships...',
    'Evaluating conversion patterns...'
  ],
  dashboard: [
    'Analyzing your metrics...',
    'Reviewing performance data...',
    'Gathering insights...',
    'Preparing recommendations...'
  ],
  default: [
    'Thinking...',
    'Analyzing your request...',
    'Gathering context...',
    'Preparing response...'
  ]
}

/**
 * Get thinking messages for a given context module.
 */
export function getThinkingMessages(module?: string): string[] {
  if (module && THINKING_MESSAGES[module]) {
    return THINKING_MESSAGES[module]
  }
  return THINKING_MESSAGES.default
}
